exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".expected-artifact-selector img.artifact-icon,\n.expected-artifact-multi-selector img.artifact-icon {\n  margin-right: 4px;\n}\n", ""]);

